import axios from 'axios';
import { $closest, $remove } from 'fxdom/es';

export const closePopup = async (e) => {
  $remove($closest('.studio-pc-info', e.currentTarget));
  try {
    await axios.post(`/${T.lang}/@api/session/check_pc_info`);
  } catch (e) {}
};
